import fetchJSON from '@api/api_helper';

const getUrl = (assetKey) => `/api/v4/assets/${assetKey}`;

export default (options, updateFetchControllers) => (
  fetchJSON(getUrl(options.assetKey), options, updateFetchControllers)
);

// helper: returns custom fields as an object
export const formatCustomFields = (response) => {
  if (!response.included) { return undefined; }

  const formattedCustomFields = {};

  response.included.forEach((field) => {
    formattedCustomFields[field.attributes.key] = field.attributes.value;
  });

  return formattedCustomFields;
};
